'use strict';

function ListChooseController(
    $scope,
    $mdDialog,
    lists
) {
    'ngInject';

    $scope.lists = lists;
    $scope.btnDisabled = true;

    $scope.save = function() {
        $mdDialog.hide({
            list: this.selectedList
        });
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };
}

export default ListChooseController;
